// extracted by mini-css-extract-plugin
export default {"BackgroundBlur":"ScreenLayout_BackgroundBlur__JFXEs"};